<template>
    <tbody v-if="extensionData">
        <tr v-for="(item, index) in extensionDataArr" :key="'recording'+index">
            <!-- Title -->
            <td colspan="2" class="label-input-type" v-if="(item.customFieldTypeCode == 'LABEL')" >
                <p>{{item.name}}</p>
            </td>
            <!-- <td colspan="2" v-if="(item.customFieldTypeCode == 'LABEL')" >
                <label-style :field="item"></label-style>
            </td> -->
            <td v-else>{{item.name || '-'}}</td>

            <!-- Value -->
            <td v-if="(item.customFieldTypeCode === 'PARAGRAPH')">
                <div class="editor__content" v-html="item.value"></div>
            </td>
            <td v-else-if="(item.customFieldTypeCode === 'EMAIL')">
                <a :class="{'email-link': item.value? true: false}" :href="`mailto:${item.value}`">{{item.value || '-'}}</a>
            </td>
            <td v-else-if="(item.customFieldTypeCode === 'PHOTOS' && item.valueObject.length>0) || (item.customFieldTypeCode === 'SIGNATURE' && item.valueObject.length>0)">
                <img class="recording-img" :src="img.FileUrl" v-for="(img, index) in item.valueObject" :key="'img' + index" @click="enlargeImg(img.FileUrl)">
            </td>
            <td v-else-if="item.customFieldTypeCode === 'VIDEOS' && item.valueObject.length>0">
                <video-player :videoUrl="video.FileUrl" v-for="(video, index) in item.valueObject" :key="'video' + index"></video-player>
            </td>
            <td v-else-if="item.customFieldTypeCode === 'AUDIO' && item.valueObject.length>0">
                <audio-player :audioUrl="audio.FileUrl" v-for="(audio, index) in item.valueObject" :key="'audio' + index"></audio-player>
            </td>
            <td v-else-if="item.customFieldTypeCode === 'FILES' && item.valueObject.length>0">
                <a class="file-link" :href="file.FileUrl" v-for="(file, index) in item.valueObject" :key="'files' + index">File {{index+1}}</a>
            </td>
            <td v-else>{{$_formatTextWithIputTypeCode(item.value, item.customFieldTypeCode)}}</td>
        </tr>

        <el-dialog
            title="Image"
            :visible.sync="dialogVisible"
            width="700px">
            <div class="img-container" >
                <img class="img-src" :src="imgSrc" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size='small' @click="dialogVisible = false">Cancel</el-button>
                <el-button size='small' type="primary" @click="downloadImg()">Download</el-button>
            </span>
        </el-dialog>
    </tbody>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'
import AudioPlayer from '@/components/AudioPlayer'
import LabelStyle from '@/components/Form/LabelStyle'

    export default {
        props: {
            extensionData: {
                type: Object,
            },
            extensionDataPath: {
                type: String,
            }
        },
        components: {
            'video-player': VideoPlayer,
            'audio-player': AudioPlayer,
            'label-style': LabelStyle,
        },
        data() {
            return {
                dialogVisible: false,
                imgSrc: null
            }
        },
        computed: {
            extensionDataArr() {
                return _.get(this.extensionData, this.extensionDataPath);
            }
        },
        methods: {
            enlargeImg(url) {
                this.dialogVisible = true
                this.imgSrc = url
            },
            downloadImg() {
                this.dialogVisible = false
                setTimeout(() => {
                    this.$_downloadMedia(this.imgSrc)
                }, 200);
            }
        },
    }
</script>

<style lang="css" scoped>
.recording-img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    display: inline-block;
    margin: var(--space-4);
    border: 1px solid var(--border-line);
    border-radius: 4px;
    cursor: pointer;
}
.img-container{
    text-align: center;
}
.img-src{
    width: 400px;
    height: auto;
}
.file-link{
    margin: var(--space-8) 0;
    display: block;
    text-decoration: underline;
    color: var(--sidebar-active-text);
}
.label-input-type {
    width: 100%;
}
.paragraph-container {
    border: 1px solid var(--seperation-line-grey);
    border-radius: 4px;
    padding: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/ExtensionDataDetail/index.vue